import { DesktopMenu, MobileMenu } from '@Components/menu'
import { NavbarResponse } from '../../apis/navbar'

interface NavBarProps {
  navbar?: NavbarResponse
}
const NavBar = ({ navbar }: NavBarProps) => {
  return (
    <div className='relative block w-full'>
      <div className='hidden lg:block'>
        <DesktopMenu menus={navbar?.Menus ?? []} logo={navbar?.Logo ?? null} />
      </div>
      <div className='block lg:hidden'>
        <MobileMenu menus={navbar?.Menus ?? []} logo={navbar?.Logo ?? null} />
      </div>
    </div>
  )
}

export default NavBar
